var React = require('react');

function Document (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M336 16l80 80v400H96V16z","fill":"#badaef","key":0}),React.createElement("path",{"d":"M336 16v80h80z","fill":"#ececec","key":1}),React.createElement("path",{"d":"M128 368h224v32H128zm0-48h256v32H128zm0-48h256v32H128zm0-80h240v32H128zm0-52h256v32H128z","fill":"gray","key":2})]);
}

Document.defaultProps = {"viewBox":"0 0 512 512"};

module.exports = Document;

Document.default = Document;
